export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(value);
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('en-US').format(value);
}

export function formatCompact(value: number): string {
  if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
  return String(value);
}

export function formatPercent(value: number, decimals: number = 1): string {
  return `${value >= 0 ? '+' : ''}${value.toFixed(decimals)}%`;
}

export function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function formatDateShort(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function formatDateTime(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function formatPhone(phone: string, masked: boolean = false): string {
  const digits = phone.replace(/\D/g, '');
  if (digits.length < 10) return phone;
  if (masked) {
    return `(***) ***-${digits.slice(-4)}`;
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

export function formatPoints(points: number): string {
  return `${formatNumber(points)} pts`;
}

export function formatDelta(value: number | null): { text: string; color: string; arrow: string } {
  if (value === null || value === undefined) {
    return { text: 'N/A', color: 'var(--t3)', arrow: '' };
  }
  if (value > 0) {
    return { text: `+${value.toFixed(1)}%`, color: 'var(--green)', arrow: '↑' };
  }
  if (value < 0) {
    return { text: `${value.toFixed(1)}%`, color: 'var(--red)', arrow: '↓' };
  }
  return { text: '0%', color: 'var(--t3)', arrow: '—' };
}
